<template>
    <hts-drawer
        v-model="visible"
        :rules="rulesCompany"
        :submit="submit"
        :reset="reset"
        :title="$t('labels.editCompanyInformation')">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card
                    class="card"
                    :title="$t('labels.generalInformation')">
                    <div class="grid gap-4">
                        <hts-form-input
                            v-model="formData.name"
                            :label="$t('labels.companyName')"
                            :required="true"
                            name="companyName"
                            prop="companyName" />
                        <hts-form-input
                            v-model="formData.address"
                            :label="$t('labels.address')"
                            :required="true"
                            name="address"
                            prop="address" />
                        <hts-form-input
                            v-model="formData.website"
                            :label="$t('labels.website')"
                            name="website"
                            prop="website" />
                        <hts-form-input
                            v-model="formData.taxNumber"
                            :label="$t('labels.taxNumber')"
                            name="taxNumber"
                            prop="taxNumber"
                            :required="true" />
                        <hts-form-input
                            v-model="formData.fax"
                            :label="$t('labels.fax')"
                            name="fax"
                            prop="fax" />
                        <hts-form-phone
                            v-model="formData.phone"
                            :label="$t('labels.phone')"
                            autocomplete
                            name="phone"
                            prop="phone"
                            required />
                        <hts-form-input
                            v-model="formData.contactEmail"
                            :label="$t('labels.contactEmail')"
                            name="contactEmail"
                            prop="contactEmail"
                            required />
                    </div>
                </hts-card>
            </div>
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
import { ICompany } from '../information.vue'
const { $disableReactive } = useNuxtApp()

const store = $store()
const visible = ref(false)
const formData = ref<ICompany>({
  name: '',
  address: '',
  website: '',
  logoUrl: '',
  taxNumber: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  fax: '',
  contactEmail: ''
})
const initData = ref<ICompany>({
  name: '',
  address: '',
  website: '',
  logoUrl: '',
  taxNumber: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  fax: '',
  contactEmail: ''
})

const emits = defineEmits(['close', 'reset', 'update'])

const show = (companyData: any) => {
  resetForm(companyData)
  visible.value = true
}
const hide = () => {
  visible.value = false
  emits('close')
}
defineExpose({
  show,
  hide
})

const rulesCompany = {
  companyName: 'required',
  address: 'required',
  taxNumber: 'required',
  phone: 'required',
  contactEmail: 'required|regexEmail'
}

const resetForm = (companyData?: any) => {
  if (companyData) {
    if (!companyData.phone || typeof companyData.phone === 'string') {
      companyData.phone = {
        phone: companyData.phone || '',
        code: '+84',
        countryCode: 'Vietnam +84'
      }
    }

    if (!companyData.address) {
      companyData.address = ''
    }

    if (!companyData.taxNumber) {
      companyData.taxNumber = ''
    }

    if (!companyData.website) {
      companyData.website = ''
    }

    if (!companyData.fax) {
      companyData.fax = ''
    }

    if (!companyData.contactEmail) {
      companyData.contactEmail = ''
    }

    formData.value = $disableReactive(companyData)
    initData.value = $disableReactive(companyData)
  } else {
    formData.value = {
      name: '',
      address: '',
      website: '',
      logoUrl: '',
      taxNumber: '',
      phone: {
        countryCode: '',
        phone: '',
        code: ''
      },
      fax: '',
      contactEmail: ''
    }
  }
  emits('reset')
}

const submit = async () => {
  const result = await $api($url.company.updateCompanyInfo, { body: formData.value })
  const data: any = $lodash.get(result, 'data.value')
  const newData = data.data || {}
  if (data.success) {
    hide()
    store.system.setCompany(newData)
    emits('update', newData)
    $toast().success($t('labels.updateSuccess'))
  }
}
const reset = () => {
  resetForm(initData.value)
}
</script>
